import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=3f6c4e99&scoped=true&"
import script from "./PageContainer.vue?vue&type=script&lang=js&"
export * from "./PageContainer.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PageContainer.vue?vue&type=style&index=0&id=3f6c4e99&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3f6c4e99",
  "05cfdf9d"
  
)

export default component.exports